module.exports = __webpack_public_path__ + "img/salary_range.0f8541de.svg";